import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";
import { ChevronRight, ExternalLink, RefreshCw } from "lucide-react";
import { PRIORITIES, STATUSES, PriorityBadge, StatusBadge, fmtDate, btn } from "../../components/leads/PriorityBadge";
import { SectionTabs } from "../../components/leads/SectionTabs";

const FILTERS = [["all", "Todos"], ["high", "Alta"], ["medium", "Media"], ["low", "Baja"]];

const LeadRow = ({ l }) => (
  <Link to={`/app/admin/leads/${l.id}`} data-testid={`lead-item-${l.id}`}
    style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.06)", color: "#fff", textDecoration: "none" }}>
    <div style={{ minWidth: 0, display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
      <PriorityBadge p={l.priority} testid={`lead-priority-${l.id}`} />
      <StatusBadge s={l.status} testid={`lead-status-${l.id}`} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontWeight: 700 }}>
          {l.player_name} · {l.age} años
          {l.is_minor && <span style={{ color: "#facc15", fontSize: 11, marginLeft: 8, letterSpacing: "0.1em" }}>MENOR</span>}
          {l.submission_count > 1 && <span style={{ color: "#60a5fa", fontSize: 11, marginLeft: 8, letterSpacing: "0.1em" }}>{l.submission_count} ENVÍOS</span>}
        </div>
        <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 3 }}>{l.budget_label} · {l.phone} · Entrada {fmtDate(l.created_at)}</div>
      </div>
    </div>
    <ChevronRight size={18} style={{ flexShrink: 0, color: "#737373" }} />
  </Link>
);

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [status, setStatus] = useState("all");
  const load = async () => {
    setLoading(true);
    try { setItems((await api.get("/admin/captacion")).data); } catch (e) { toast.error(formatErr(e)); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const counts = items.reduce((a, i) => ({ ...a, [i.priority]: (a[i.priority] || 0) + 1 }), {});
  const shown = items.filter((i) => (filter === "all" || i.priority === filter) && (status === "all" || (i.status || "new") === status));

  return (
    <AppShell>
      <SectionTabs active="leads" />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Leads</h1>
          <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 0" }}>Personas que han rellenado /empieza. Separados de tus clientes.</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <a href="/empieza" target="_blank" rel="noreferrer" style={btn("transparent")} data-testid="leads-open-form"><ExternalLink size={14} /> Ver formulario</a>
          <button onClick={load} style={btn("transparent")} data-testid="leads-refresh"><RefreshCw size={14} /> Actualizar</button>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
        {FILTERS.map(([k, label]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`leads-filter-${k}`}
            style={{ ...btn(filter === k ? "#dc2626" : "transparent"), borderRadius: 999, padding: "7px 14px", color: filter === k ? "#fff" : (PRIORITIES[k]?.fg || "#e5e5e5") }}>
            {label} <span style={{ opacity: 0.7 }}>{k === "all" ? items.length : counts[k] || 0}</span>
          </button>
        ))}
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="leads-filter-status"
          style={{ ...btn("transparent"), borderRadius: 999, padding: "7px 14px", background: "#0a0a0a" }}>
          <option value="all">Todos los estados</option>
          {Object.entries(STATUSES).map(([k, c]) => <option key={k} value={k}>{c.label}</option>)}
        </select>
      </div>
      <div style={{ background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 4 }} data-testid="leads-list">
        {loading && <div style={{ padding: 24, textAlign: "center", color: "#a3a3a3" }}>Cargando…</div>}
        {!loading && shown.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#a3a3a3" }} data-testid="leads-empty">No hay leads{(filter !== "all" || status !== "all") && " con estos filtros"}.</div>}
        {!loading && shown.map((l) => <LeadRow key={l.id} l={l} />)}
      </div>
    </AppShell>
  );
}
